
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.34,"time":20400,"words":68}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This website presents some of the results of research carried out under Sciences Po Médialab’s `}<a parentName="p" {...{
        "href": "https://medialab.sciencespo.fr/activites/algoglitch/"
      }}>{`Algoglitch project`}</a>{`. It combines descriptive analyses with data graphics on a corpus of press articles on the topic of AI and algorithms, spanning a 5-year period in the United States and United Kingdom. Using natural language processing applied to a press corpus, this research explores critical discourses on AI in the media sphere.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {}

